import type { Bid } from '@autobid/ui/types/Bid'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { ALL_BIDS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAllBidsSocket'
import { allBidsQueryKey } from '@autobid/ui/composables/car/useAllBids'
import { BID_TYPES } from '@autobid/ui/constants/BID_TYPES'
import { useQueryClient } from '@tanstack/vue-query'

export function useAllBidsBidOnAgent() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const bidOnAgent = () => {
    startListen({
      eventName: 'premium.USER_BID_ON_AGENT',
      callbackName: ALL_BIDS_SOCKET_CALLBACK,
      callback: (event) => {
        const queryKey = allBidsQueryKey.byCarId(event.context.carId)

        queryClient.setQueryData(queryKey, (bids?: Bid[]) => {
          if (!bids) {
            return bids
          }

          const {
            price: amount,
            userId: user_id,
            nickname: user_nickname,
            status,
            agentBid,
          } = event.context

          return [
            {
              user_id,
              user_nickname,
              amount,
              type: BID_TYPES.BID_ON_AGENT,
              timestamp: new Date(event.time * 1000).toISOString(),
              status,
              agent_bid: agentBid,
            },
            ...bids,
          ]
        })
      },
    })
  }

  return { bidOnAgent }
}
